import * as Yup from 'yup';
import moment from 'moment';

const formSchema = Yup.object().shape({
  vehicleManagementId: Yup.number().required('Necessário selecionar um veículo'),
  cityOrigin: Yup.number().required(
    'Cidade não cadastrada na base Cooperplace. Solicite cadastro para prosseguir',
  ),
  cityDestination: Yup.number().required(
    'Cidade não cadastrada na base Cooperplace. Solicite cadastro para prosseguir',
  ),
  latOrigin: Yup.number().required('Necessário selecionar uma cidade de origem com latitude'),
  latDestination: Yup.number().required('Necessário selecionar uma cidade de destino com latitude'),
  longOrigin: Yup.number().required('Necessário selecionar uma cidade de origem com longitude'),
  longDestination: Yup.number().required(
    'Necessário selecionar uma cidade de destino com longitude',
  ),
  typeTravel: Yup.string().nullable().required('Necessário selecionar um tipo de viagem'),
  dateOrigin: Yup.string()
    .nullable()
    .test('invalidOriginDate', 'Data inválida', (value) =>
      value ? moment(value, moment.ISO_8601, true).isValid() : true,
    )
    .required('Necessário selecionar uma data'),

  dateDestination: Yup.string()
    .nullable()
    .test('invalidDestinationDate', 'Data inválida', (value) =>
      value ? moment(value, moment.ISO_8601, true).isValid() : true,
    )
    .test(
      'isAfterDateOrigin',
      'A data de destino não pode ser anterior à data de origem',
      function (value) {
        const { dateOrigin } = this.parent;
        if (value && dateOrigin) {
          return moment(value, moment.ISO_8601, true).isSameOrAfter(
            moment(dateOrigin, moment.ISO_8601, true),
          );
        }
        return true;
      },
    )
    .required('Necessário selecionar uma data'),
});

export default formSchema;
